module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.onlyMyBtn) ? _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ['developer-info', _vm.showBgblue ? 'developer-info-blue' : '']
  }, [_vm._m(0), _vm._v(" "), (!_vm.showNotice) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.$t("projectOrder.informationCenter")))]) : _vm._e(), _vm._v(" "), (_vm.showNotice) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.isShowMyBtn) ? _c('el-dropdown', {
    staticClass: "developer-info-dropdown",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n        我的"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.commandOptions), function(item) {
    return _c('el-dropdown-item', {
      key: item.value,
      attrs: {
        "command": item.value,
        "disabled": item.disabled
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isDialogVisible) ? _c('configSettingDialog', {
    attrs: {
      "visible": _vm.isDialogVisible,
      "permissions": _vm.permissions
    },
    on: {
      "update:visible": function($event) {
        _vm.isDialogVisible = $event
      }
    }
  }) : _vm._e()], 1) : _c('el-dropdown', {
    staticClass: "developer-info-dropdown",
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('div', {
    staticClass: "color2980"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.name))]), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_vm._l((_vm.commandOptions), function(item) {
    return _c('el-dropdown-item', {
      key: item.value,
      attrs: {
        "command": item.value,
        "disabled": item.disabled
      }
    }, [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), (_vm.isDialogVisible) ? _c('configSettingDialog', {
    attrs: {
      "visible": _vm.isDialogVisible,
      "permissions": _vm.permissions
    },
    on: {
      "update:visible": function($event) {
        _vm.isDialogVisible = $event
      }
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo1.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-right": "10px",
      "background": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "position": "relative",
      "top": "2px"
    },
    attrs: {
      "src": require("../../assets/img/通知.png"),
      "alt": "通知"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('div', [_vm._v("重要通知：为更好的服务您进行订单交付管理，请您尽快激活飞书账号（已激活请忽视），系统近期将校验未激活则无法下单,")]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "color": "red",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://oppeinlink.feishu.cn/wiki/UUZTwgxgiiA2pXkg41Xc6u2snVe",
      "target": "_blank"
    }
  }, [_vm._v("\n          激活链接：https://oppeinlink.feishu.cn/wiki/UUZTwgxgiiA2pXkg41Xc6u2snVe>")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c46c8c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/index.vue
// module id = 2417
// module chunks = 68